import * as logLevel from "loglevel";

// generate unique id (without an external library!!! yay.)
export const uuid = () => {
  return "" + crypto.randomUUID();
};
export const logger = logLevel;
